import { render, staticRenderFns } from "./PortalAiAssistant.vue?vue&type=template&id=36fc4ad2&scoped=true"
import script from "./PortalAiAssistant.vue?vue&type=script&lang=js"
export * from "./PortalAiAssistant.vue?vue&type=script&lang=js"
import style0 from "./PortalAiAssistant.vue?vue&type=style&index=0&id=36fc4ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fc4ad2",
  null
  
)

export default component.exports